// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Options__container___1gMsL{margin:128px 24px 80px}@media (max-width:719px){.Options__container___1gMsL{margin:54px 24px 80px}}.Options__wrapper___1HRN8{width:90%;max-width:720px;text-align:center}.Options__wrapper___1HRN8 .Options__title___3qtC2{color:inherit;font-weight:500;padding:0 10px;color:#2c2302;font-weight:200;font-size:40px;line-height:56px}.Options__wrapper___1HRN8 .Options__description___3C4X6{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#6b6651}.Options__wrapper___1HRN8 .Options__option_description___2RX6V{color:inherit;font-weight:400;font-size:20px;line-height:32px;margin:40px 0;color:#2c2302}@media (max-width:719px){.Options__wrapper___1HRN8 .Options__optionMenu___44z_w{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Options__container___1gMsL",
	"wrapper": "Options__wrapper___1HRN8",
	"title": "Options__title___3qtC2",
	"description": "Options__description___3C4X6",
	"option_description": "Options__option_description___2RX6V",
	"optionMenu": "Options__optionMenu___44z_w"
};
module.exports = ___CSS_LOADER_EXPORT___;
